import { cn } from "@/lib/utils";

export const STATUS_STYLES = {
  New: "bg-sky-500/15 text-sky-600 dark:text-sky-300 border-sky-500/30",
  "ID Under Review": "bg-amber-500/15 text-amber-600 dark:text-amber-300 border-amber-500/30",
  "Interview Scheduled": "bg-purple-500/15 text-purple-600 dark:text-purple-300 border-purple-500/30",
  Interviewed: "bg-indigo-500/15 text-indigo-600 dark:text-indigo-300 border-indigo-500/30",
  Approved: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-300 border-emerald-500/30",
  Declined: "bg-red-500/15 text-red-600 dark:text-red-300 border-red-500/30",
  "Cash Payment Received": "bg-orange-500/15 text-orange-600 dark:text-orange-300 border-orange-500/30",
  "Active Member": "bg-emerald-600 text-white border-emerald-600",
  Suspended: "bg-zinc-500/20 text-zinc-600 dark:text-zinc-300 border-zinc-500/40",
  Scheduled: "bg-purple-500/15 text-purple-600 dark:text-purple-300 border-purple-500/30",
  Completed: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-300 border-emerald-500/30",
};

export const StatusBadge = ({ status, testId }) => (
  <span data-testid={testId} className={cn("inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-bold", STATUS_STYLES[status] || "bg-muted")}>
    {status}
  </span>
);
